var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-doctor-locator" },
    [
      _c("rb-modal", {
        attrs: {
          show: _vm.isVisible,
          "handle-close": _vm.closeModal,
          "modal-wrapper-class": "doctor-locator",
          "modal-class": "rb-doctor-locator-modal",
          "modal-class-container": "rb-doctor-locator-modal__container",
        },
        scopedSlots: _vm._u([
          {
            key: "modal-header",
            fn: function () {
              return [
                _c(
                  "span",
                  {
                    staticClass:
                      "rb-modal-header__icon common__icon common__icon--red-logo",
                  },
                  [_vm._v("ray-ban-red-logo")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "modal-content",
            fn: function () {
              return [
                _c("iframe", {
                  staticClass: "rb-doctor-locator-modal__iframe",
                  attrs: {
                    allow: _vm.allow,
                    src: _vm.script,
                    title: "Doctor Locator",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal-portal", { staticClass: "modal-wrapper--doctor-locator" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }